import { signTypedData as _signTypedData } from '@wagmi/core';
import { Address, Hex } from 'viem';
import { privateKeyToAccount as _privateKeyToAccount, privateKeyToAddress } from 'viem/accounts';
import { Config } from 'wagmi';
import { CancelOrderSignatureMessage, SignatureType } from '../../constants';
import { SchemaCancelOrderDto, SchemaDomainTypeDto } from '../../generated/apiTypes';
import { getSpecificSignatureType, SignTypedDataTypes } from '../../hooks/useDataForSigning';
import { SubaccountData } from '../../hooks/useWalletStorage';
import { getNonceInNanoseconds } from '../../lib/time';
import { uuidToBytes32 } from '../../lib/uuid';

type GetCancelOrderBodyParams = {
  orderIds: string[];
  subaccountData: SubaccountData | undefined;
  selectedSubaccount: Hex;
  address: Address;
  domain: SchemaDomainTypeDto;
  signedTypedDataTypes: SignTypedDataTypes;
  config: Config;
};
export const getCancelOrderBody = async (
  params: GetCancelOrderBodyParams,
  deps = { privateKeyToAccount: _privateKeyToAccount, signTypedData: _signTypedData }
) => {
  const sender =
    params.subaccountData?.signingMethod === 'one-click'
      ? privateKeyToAddress(params.subaccountData.signerKey)
      : params.address;
  const message = {
    subaccount: params.selectedSubaccount,
    sender,
    nonce: getNonceInNanoseconds(),
    orderIds: params.orderIds.map((id) => uuidToBytes32(id)),
  } satisfies CancelOrderSignatureMessage;

  const signature =
    params.subaccountData?.signingMethod === 'one-click'
      ? await deps.privateKeyToAccount(params.subaccountData.signerKey).signTypedData({
          domain: params.domain,
          types: getSpecificSignatureType(params.signedTypedDataTypes, SignatureType.CANCEL_ORDER),
          primaryType: SignatureType.CANCEL_ORDER,
          message,
        })
      : await deps.signTypedData(params.config, {
          domain: params.domain,
          types: getSpecificSignatureType(params.signedTypedDataTypes, SignatureType.CANCEL_ORDER),
          primaryType: SignatureType.CANCEL_ORDER,
          message,
        });
  const data = {
    sender: message.sender,
    subaccount: params.selectedSubaccount,
    nonce: message.nonce.toString(),
    orderIds: params.orderIds,
  };
  return { data, signature } satisfies SchemaCancelOrderDto;
};
